<template>
  <div class="notification-settings">
    <div class="notification-settings-header-container">
      <div class="notification-settings-header-mobile">
        <mobile-topbar
          :left-icon="isViewMode ? 'icon-Aula_app_arrow_slideback' : null"
          :left-text="isViewMode ? null : 'CANCEL'"
          :text-key="isViewMode ? 'MOBILE_NOTIFICATION_SETTINGS_TITLE_SHORT' : 'MOBILE_NOTIFICATION_SETTINGS_EDIT'"
          :right-text-icon="isViewMode ? 'icon-Aula_edit_pen' : null"
          :right-text="isViewMode ? 'BUTTON_EDIT_SMALL' : 'BUTTON_SAVE_SMALL'"
          :background-color="null"
          :color="null"
          :css-class="isViewMode ? 'notification-settings-view-mode-header' : 'notification-settings-edit-mode-header'"
          @leftIconClicked="goBackNotification()"
          @leftTextClicked="handleEditCancelled()"
          @rightTextClicked="isViewMode ? initEditMode() : saveChanges()"
        />
      </div>
      <div class="notification-settings-body-mobile" :class="isViewMode ? 'view-mode' : 'edit-mode'">
        <template v-if="notificationSettingModel.getEmailAvailable()">
          <div class="strong-label">
            {{ $getText('NOTIFICATION_SETTINGS_FROM') }}
          </div>
          <div class="item upper-case mt-1">
            <i class="icon-Aula_write icon-border" />
            {{ $getText('MESSAGE_HEADER_TITLE') }}
          </div>
          <div class="item">
            <span class="item-label font-weight-normal">
              {{ $getText('NOTIFICATION_SETTINGS_EMPLOYEES') }}
            </span>
            <span v-if="isViewMode" class="view-mode-mobile pull-right">
              {{
                notificationSettingModel.getMessagesFromEmployees()
                  ? $getText('NOTIFICATION_SETTINGS_SHORT_YES')
                  : $getText('NOTIFICATION_SETTINGS_SHORT_NO')
              }}
            </span>
            <el-switch
              v-else
              :value="notificationSettingModel.getMessagesFromEmployees()"
              :width="(width = 48)"
              class="pull-right"
              @change="updateMessagesFromEmployees"
            />
          </div>
          <div class="item">
            <span class="item-label font-weight-normal">
              {{ $getText('NOTIFICATION_SETTINGS_GUARDIANS') }}
            </span>
            <span v-if="isViewMode" class="view-mode-mobile pull-right">
              {{
                notificationSettingModel.getMessagesFromGuardians()
                  ? $getText('NOTIFICATION_SETTINGS_SHORT_YES')
                  : $getText('NOTIFICATION_SETTINGS_SHORT_NO')
              }}
            </span>
            <el-switch
              v-else
              :value="notificationSettingModel.getMessagesFromGuardians()"
              :width="(width = 48)"
              class="pull-right"
              @change="updateMessagesFromGuardians"
            />
          </div>
          <div class="item">
            <span class="item-label font-weight-normal">
              {{ $getText('NOTIFICATION_SETTINGS_CHILDREN') }}
            </span>
            <span v-if="isViewMode" class="view-mode-mobile pull-right">
              {{
                notificationSettingModel.getMessagesFromChildren()
                  ? $getText('NOTIFICATION_SETTINGS_SHORT_YES')
                  : $getText('NOTIFICATION_SETTINGS_SHORT_NO')
              }}
            </span>
            <el-switch
              v-else
              :value="notificationSettingModel.getMessagesFromChildren()"
              :width="(width = 48)"
              class="pull-right"
              @change="updateMessagesFromChildren"
            />
          </div>
          <div class="item upper-case mt-3">
            <i class="icon-Aula_calendar icon-border" />
            {{ $getText('CALENDAR_TAB_TITLE') }}
          </div>

          <div class="item">
            <span class="item-label font-weight-normal">
              {{ $getText('NOTIFICATION_SETTINGS_ALL_KALENDAR_EVENTS') }}
            </span>
            <span v-if="isViewMode" class="view-mode-mobile pull-right">
              {{
                notificationSettingModel.getCalendar()
                  ? $getText('NOTIFICATION_SETTINGS_SHORT_YES')
                  : $getText('NOTIFICATION_SETTINGS_SHORT_NO')
              }}
            </span>
            <el-switch
              v-else
              :value="notificationSettingModel.getCalendar()"
              :width="(width = 48)"
              :inactive-value="false"
              class="pull-right"
              @change="updateCalendar"
            />
          </div>
          <div v-if="profile.role === portalRoles.EMPLOYEE" class="item">
            <span class="item-label font-weight-normal">
              {{ $getText('NOTIFICATION_SETTINGS_SUBSTITUTE_TEACHER') }}
            </span>
            <span v-if="isViewMode" class="view-mode-mobile pull-right">
              {{
                notificationSettingModel.getNotifyAssignedAsSubstituteTeacher()
                  ? $getText('NOTIFICATION_SETTINGS_SHORT_YES')
                  : $getText('NOTIFICATION_SETTINGS_SHORT_NO')
              }}
            </span>
            <el-switch
              v-else
              :value="notificationSettingModel.getNotifyAssignedAsSubstituteTeacher()"
              :width="(width = 48)"
              :active-value="true"
              :inactive-value="false"
              class="pull-right"
              @change="updateNotifyAssignedAsSubstituteTeacher"
            />
          </div>
          <div v-if="profile.role === portalRoles.EMPLOYEE" class="item">
            <span class="item-label font-weight-normal">
              {{ $getText('NOTIFICATION_SETTINGS_LESSON_NOTE_CHANGED') }}
            </span>
            <span v-if="isViewMode" class="view-mode-mobile pull-right">
              {{
                notificationSettingModel.getNotifyLessonNoteChanged()
                  ? $getText('NOTIFICATION_SETTINGS_SHORT_YES')
                  : $getText('NOTIFICATION_SETTINGS_SHORT_NO')
              }}
            </span>
            <el-switch
              v-else
              :value="notificationSettingModel.getNotifyLessonNoteChanged()"
              :width="(width = 48)"
              :active-value="true"
              :inactive-value="false"
              class="pull-right"
              @change="updateNotifyLessonNoteChanged"
            />
          </div>
          <div class="item upper-case mt-3">
            <i class="icon-Aula_picture icon-border" />
            {{ $getText('GALLERY_TITLE') }}
          </div>
          <div class="item">
            <span class="item-label font-weight-normal">
              {{ $getText('NOTIFICATION_SETTINGS_ALL_MEDIA') }}
            </span>
            <span v-if="isViewMode" class="view-mode-mobile pull-right">
              {{
                notificationSettingModel.getGallery()
                  ? $getText('NOTIFICATION_SETTINGS_SHORT_YES')
                  : $getText('NOTIFICATION_SETTINGS_SHORT_NO')
              }}
            </span>
            <el-switch
              v-else
              :value="notificationSettingModel.getGallery()"
              :width="(width = 48)"
              :active-value="true"
              :inactive-value="false"
              class="pull-right"
              @change="updateGallery"
            />
          </div>
          <div class="item upper-case mt-3">
            <i class="icon-Aula_home icon-border" />
            {{ $getText('POSTS_PAGETITLE') }}
          </div>
          <div class="item">
            <span class="item-label font-weight-normal">
              {{ $getText('NOTIFICATION_SETTINGS_ALL_POSTS') }}
            </span>
            <span v-if="isViewMode" class="view-mode-mobile pull-right">
              {{
                notificationSettingModel.getPost()
                  ? $getText('NOTIFICATION_SETTINGS_SHORT_YES')
                  : $getText('NOTIFICATION_SETTINGS_SHORT_NO')
              }}
            </span>
            <el-switch
              v-else
              :value="notificationSettingModel.getPost()"
              :width="(width = 48)"
              :active-value="true"
              :inactive-value="false"
              class="pull-right"
              @change="updatePost"
            />
          </div>
          <template v-if="profile.role === portalRoles.GUARDIAN || profile.role === portalRoles.OTP">
            <div class="item upper-case mt-3">
              <i class="icon-Kommegaa_ikon icon-border" />
              {{ $getText('PRESENCE_PAGETITLE') }}
            </div>
            <div class="item">
              <span class="item-label font-weight-normal">
                {{ $getText('NOTIFICATION_SETTINGS_PICKUP_ACTIVITIES') }}
              </span>
              <span v-if="isViewMode" class="view-mode-mobile pull-right">
                {{
                  notificationSettingModel.getPickUpActivity()
                    ? $getText('NOTIFICATION_SETTINGS_SHORT_YES')
                    : $getText('NOTIFICATION_SETTINGS_SHORT_NO')
                }}
              </span>
              <el-switch
                v-else
                :value="notificationSettingModel.getPickUpActivity()"
                :width="(width = 48)"
                :active-value="true"
                :inactive-value="false"
                class="pull-right"
                @change="updatePickUpActivity"
              />
            </div>
            <div class="item">
              <span class="item-label font-weight-normal">
                {{ $getText('NOTIFICATION_SETTINGS_VACATION_REQUESTS') }}
              </span>
              <span v-if="isViewMode" class="view-mode-mobile pull-right">
                {{
                  notificationSettingModel.getVacationRequest()
                    ? $getText('NOTIFICATION_SETTINGS_SHORT_YES')
                    : $getText('NOTIFICATION_SETTINGS_SHORT_NO')
                }}
              </span>
              <el-switch
                v-else
                :value="notificationSettingModel.getVacationRequest()"
                :width="(width = 48)"
                :active-value="true"
                :inactive-value="false"
                class="pull-right"
                @change="updateVacationRequest"
              />
            </div>
          </template>
          <div class="widget-settings">
            <div
              v-for="widgetSetting in notificationSettingModel.getWidgetSettings()"
              :key="widgetSetting.widgetId"
              class="widget-setting"
            >
              <div class="item upper-case mt-3">
                <i class="icon-Aula_widget icon-border" />
                {{ widgetSetting.title }}
              </div>
              <div class="item">
                <span class="item-label font-weight-normal">
                  {{ $getText('NOTIFICATION_SETTINGS_WIDGET_ACTIVATED') }}
                </span>
                <span v-if="isViewMode" class="view-mode-mobile pull-right">
                  {{
                    widgetSetting.isActive
                      ? $getText('NOTIFICATION_SETTINGS_SHORT_YES')
                      : $getText('NOTIFICATION_SETTINGS_SHORT_NO')
                  }}
                </span>
                <el-switch
                  v-else
                  :value="widgetSetting.isActive"
                  :width="(width = 48)"
                  :active-value="true"
                  :inactive-value="false"
                  class="pull-right"
                  @change="updateWidget(widgetSetting.widgetId, $event)"
                />
              </div>
            </div>
          </div>
        </template>
        <div class="strong-label">
          {{ $getText('MOBILE_NOTIFICATION_SETTINGS_PLATFORM_MENU') }}
        </div>
        <div class="item upper-case">
          <i class="icon-Aula_mobile icon-border" />
          {{ $getText('MOBILE_NOTIFICATION_SETTINGS_MOBILE_MENU') }}
        </div>
        <div v-if="notificationSettingModel.getAppAvailable()" class="item">
          <div class="py-2">
            {{ $t('settings.app_notification_description') }}
          </div>
        </div>
        <div v-if="!notificationSettingModel.getAppAvailable()" class="item">
          <div>
            {{ $getText('NOTIFICATION_SETTINGS_NO_APP') }}
          </div>
          <br />
          <div class="mb-2">
            {{ $getText('NOTIFICATION_SETTINGS_DOWNLOAD') }}
          </div>
          <a href="https://itunes.apple.com/" :aria-label="$getText('ARIA_LABEL_APP_STORE')">
            <img class="image-link" src="../../../static/appstores/app_store.svg" alt="" />
          </a>
          <a href="https://play.google.com/store/apps/" :aria-label="$getText('ARIA_LABEL_GOOGLE_PLAY')">
            <img class="image-link" src="../../../static/appstores/app_google_play.svg" alt="" />
          </a>
          <br />
        </div>
        <div class="item upper-case">
          <i class="icon-Aula_email icon-border" />
          {{ $getText('MOBILE_NOTIFICATION_SETTINGS_EMAIL_MENU') }}
        </div>
        <div v-if="!notificationSettingModel.getEmailAvailable()" class="item">
          <div>
            {{ $getText('NOTIFICATION_SETTINGS_NO_EMAIL') }}
          </div>
          <br />
          <div>
            {{ $getText('NOTIFICATION_SETTINGS_ENTER_EMAIL') }}
          </div>
        </div>
        <div v-else class="item">
          <div class="item-child d-block">
            <span class="item-label font-weight-normal">
              {{ $getText('MOBILE_NOTIFICATION_SETTINGS_EMAIL_ALLOW_LABEL') }}
            </span>
            <span v-if="isViewMode" class="view-mode-mobile pull-right">
              {{
                notificationSettingModel.getEmailDisabled()
                  ? $getText('NOTIFICATION_SETTINGS_SHORT_YES')
                  : $getText('NOTIFICATION_SETTINGS_SHORT_NO')
              }}
            </span>
            <el-switch
              v-else
              :value="notificationSettingModel.getEmailDisabled()"
              :width="(width = 48)"
              :active-value="true"
              :inactive-value="false"
              class="pull-right"
              @change="updateEmailDisabled"
            />
          </div>
          <template v-if="!isViewMode || notificationSettingModel.getEmailDisabled()">
            <b-alert variant="danger" :show="areAllEmailsEmpty" class="settings-content">
              {{ emailRequiredLabel }}
            </b-alert>
            <NotificationContactForm
              v-for="institutionProfile in institutionProfiles"
              :key="`contact-${institutionProfile.id}`"
              class="settings-content"
              :institution-profile="institutionProfile"
              :show-institution-name="institutionProfiles.length > 1"
              :disabled="isViewMode || !institutionProfile.currentUserCanEditContactInformation"
              :user-role="profile.role"
              @input="emitEmailInput"
            />
          </template>
          <template v-if="notificationSettingModel.getEmailDisabled()">
            <div class="item-child d-block">
              <span class="item-label font-weight-normal">
                {{ $getText('MOBILE_NOTIFICATION_SETTINGS_EMAIL_EVERY_TIME') }}
              </span>
              <span v-if="isViewMode" class="view-mode-mobile pull-right">
                {{
                  $getText(
                    notificationSettingModel.getInstant()
                      ? 'NOTIFICATION_SETTINGS_SHORT_YES'
                      : 'NOTIFICATION_SETTINGS_SHORT_NO'
                  )
                }}
              </span>
              <el-switch
                v-else
                :value="notificationSettingModel.getInstant()"
                :width="(width = 48)"
                :active-value="true"
                :inactive-value="false"
                class="pull-right"
                @change="updateInstant"
              />
            </div>
            <div class="item-child d-block">
              <span class="item-label font-weight-normal">
                {{ $getText('MOBILE_NOTIFICATION_SETTINGS_EMAIL_AFTER_TIME_INTERVAL') }}
              </span>
              <span v-if="isViewMode" class="view-mode-mobile pull-right">
                {{
                  $getText(
                    !notificationSettingModel.getInstant()
                      ? 'NOTIFICATION_SETTINGS_SHORT_YES'
                      : 'NOTIFICATION_SETTINGS_SHORT_NO'
                  )
                }}
              </span>
              <el-switch
                v-else
                :value="notificationSettingModel.getInstant()"
                :width="(width = 48)"
                :active-value="false"
                :inactive-value="true"
                class="pull-right"
                @change="updateInstant"
              />
            </div>
          </template>
        </div>
        <div v-if="notificationSettingModel.getEmailDisabled() && !notificationSettingModel.getInstant()" class="item">
          <div class="item-child item-time-picker">
            <div class="item-label">
              {{ $getText('MOBILE_NOTIFICATION_SETTINGS_TIME_LABEL') }}
            </div>
            <div :class="showNoDaySelected ? 'red-border' : ''">
              <AulaTimepicker
                :value="notificationSettingModel.getScheduledTime()"
                format="HH:mm"
                hour-label="Time"
                minute-label="Minut"
                :placeholder="$getText('MESSAGE_PLACEHOLDER_SELECT_TIME')"
                :aria-label="$getText('ARIA_LABEL_CALENDAR_START_TIME')"
                hide-clear-button
                :minute-interval="timepickerSettings.HALF_HOUR_INTERVAL"
                advanced-keyboard
                lazy
                @input="updateScheduledTime"
              />
            </div>
          </div>
          <div class="item-child d-block">
            <span class="item-label font-weight-normal">
              {{ $getText('MOBILE_NOTIFICATION_SETTINGS_EVERY_DAY') }}
            </span>
            <span v-if="isViewMode" class="view-mode-mobile pull-right">
              {{ everyDay ? $getText('NOTIFICATION_SETTINGS_SHORT_YES') : $getText('NOTIFICATION_SETTINGS_SHORT_NO') }}
            </span>
            <el-switch v-else :value="everyDay" :width="(width = 48)" class="pull-right" @change="setAllSelectedDays" />
          </div>
          <div class="item-child">
            <div class="item-label">
              {{ $getText('NOTIFICATION_SETTINGS_SPECIFIC_DAYS') }}
            </div>
            <span class="pull-right">
              {{ $getText('NOTIFICATION_SETTINGS_SELECT_DAYS') }}
              <i
                class="icon small-icon"
                :class="showSelectDays || !isViewMode ? 'icon-Aula_up-arrow' : 'icon-Aula_down-arrow'"
              />
            </span>
            <div
              v-if="showSelectDays || !isViewMode"
              class="select-days"
              :class="showNoDaySelected ? 'red-border' : ''"
            >
              <div class="item-child d-block">
                <span class="item-label font-weight-normal">
                  {{ $getText('NOTIFICATION_SETTINGS_MONDAY') }}
                </span>
                <span v-if="isViewMode" class="view-mode-mobile pull-right">
                  {{
                    notificationSettingModel.getMonday()
                      ? $getText('NOTIFICATION_SETTINGS_SHORT_YES')
                      : $getText('NOTIFICATION_SETTINGS_SHORT_NO')
                  }}
                </span>
                <el-switch
                  v-else
                  :value="notificationSettingModel.getMonday()"
                  :width="(width = 48)"
                  class="pull-right"
                  @change="updateMonday"
                />
              </div>
              <div class="item-child d-block">
                <span class="item-label font-weight-normal">
                  {{ $getText('NOTIFICATION_SETTINGS_TUESDAY') }}
                </span>
                <span v-if="isViewMode" class="view-mode-mobile pull-right">
                  {{
                    notificationSettingModel.getTuesday()
                      ? $getText('NOTIFICATION_SETTINGS_SHORT_YES')
                      : $getText('NOTIFICATION_SETTINGS_SHORT_NO')
                  }}
                </span>
                <el-switch
                  v-else
                  :value="notificationSettingModel.getTuesday()"
                  :width="(width = 48)"
                  class="pull-right"
                  @change="updateTuesday"
                />
              </div>
              <div class="item-child d-block">
                <span class="item-label font-weight-normal">
                  {{ $getText('NOTIFICATION_SETTINGS_WEDNESDAY') }}
                </span>
                <span v-if="isViewMode" class="view-mode-mobile pull-right">
                  {{
                    notificationSettingModel.getWednesday()
                      ? $getText('NOTIFICATION_SETTINGS_SHORT_YES')
                      : $getText('NOTIFICATION_SETTINGS_SHORT_NO')
                  }}
                </span>
                <el-switch
                  v-else
                  :value="notificationSettingModel.getWednesday()"
                  :width="(width = 48)"
                  class="pull-right"
                  @change="updateWednesday"
                />
              </div>
              <div class="item-child d-block">
                <span class="item-label font-weight-normal">
                  {{ $getText('NOTIFICATION_SETTINGS_THURSDAY') }}
                </span>
                <span v-if="isViewMode" class="view-mode-mobile pull-right">
                  {{
                    notificationSettingModel.getThursday()
                      ? $getText('NOTIFICATION_SETTINGS_SHORT_YES')
                      : $getText('NOTIFICATION_SETTINGS_SHORT_NO')
                  }}
                </span>
                <el-switch
                  v-else
                  :value="notificationSettingModel.getThursday()"
                  :width="(width = 48)"
                  class="pull-right"
                  @change="updateThursday"
                />
              </div>
              <div class="item-child d-block">
                <span class="item-label font-weight-normal">
                  {{ $getText('NOTIFICATION_SETTINGS_FRIDAY') }}
                </span>
                <span v-if="isViewMode" class="view-mode-mobile pull-right">
                  {{
                    notificationSettingModel.getFriday()
                      ? $getText('NOTIFICATION_SETTINGS_SHORT_YES')
                      : $getText('NOTIFICATION_SETTINGS_SHORT_NO')
                  }}
                </span>
                <el-switch
                  v-else
                  :value="notificationSettingModel.getFriday()"
                  :width="(width = 48)"
                  class="pull-right"
                  @change="updateFriday"
                />
              </div>
              <div class="item-child d-block">
                <span class="item-label font-weight-normal">
                  {{ $getText('NOTIFICATION_SETTINGS_SATURDAY') }}
                </span>
                <span v-if="isViewMode" class="view-mode-mobile pull-right">
                  {{
                    notificationSettingModel.getSaturday()
                      ? $getText('NOTIFICATION_SETTINGS_SHORT_YES')
                      : $getText('NOTIFICATION_SETTINGS_SHORT_NO')
                  }}
                </span>
                <el-switch
                  v-else
                  :value="notificationSettingModel.getSaturday()"
                  :width="(width = 48)"
                  class="pull-right"
                  @change="updateSaturday"
                />
              </div>
              <div class="item-child d-block">
                <span class="item-label font-weight-normal">
                  {{ $getText('NOTIFICATION_SETTINGS_SUNDAY') }}
                </span>
                <span v-if="isViewMode" class="view-mode-mobile pull-right">
                  {{
                    notificationSettingModel.getSunday()
                      ? $getText('NOTIFICATION_SETTINGS_SHORT_YES')
                      : $getText('NOTIFICATION_SETTINGS_SHORT_NO')
                  }}
                </span>
                <el-switch
                  v-else
                  :value="notificationSettingModel.getSunday()"
                  :width="(width = 48)"
                  class="pull-right"
                  @change="updateSunday"
                />
              </div>
            </div>
            <b-alert variant="danger" :show="showNoDaySelected">
              {{ $getText('NOTIFICATION_SETTINGS_SAVE_FAILED') }}
            </b-alert>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { timepickerSettings } from '../../enums/timepickerSettings';
import AulaTimepicker from '../../components/Timepicker';
import { portalRoles } from '../../enums/portalRoles';
import MobileTopbar from '../../components/MobileTopbar';
import { NotificationSetting } from '../../../src/business/notificationSetting';
import NotificationContactForm from './NotificationContactForm.vue';

export default {
  name: 'NotificationSetttingMobile',
  components: {
    NotificationContactForm,
    AulaTimepicker,
    MobileTopbar,
  },
  props: {
    isLoading: { type: Boolean, default: false },
    isViewMode: { type: Boolean, default: false },
    availableAreas: { type: Array, default: () => [] },
    profile: { type: Object, default: null },
    everyDay: { type: Boolean, default: null },
    showNoDaySelected: { type: Boolean, default: null },
    showSelectDays: { type: Boolean, default: null },
    areAllEmailsEmpty: { type: Boolean, default: false },
    notificationSettingModel: { type: NotificationSetting, default: null },
    institutionProfiles: { type: Array, default: () => [] },
  },
  emits: ['emailInput'],
  data: function () {
    return {
      portalRoles,
      timepickerSettings,
    };
  },
  computed: {
    emailRequiredLabel() {
      return this.$t('settings.notification_settings_email_required');
    },
  },
  methods: {
    emitEmailInput(form) {
      this.$emit('emailInput', form);
    },
    setAllSelectedDays(value) {
      this.updateEveryDay(value);
      this.$emit('setAllSelectedDays');
    },
    updateViewMode(value) {
      this.$emit('updateViewMode', value);
    },
    goBackNotification() {
      this.$emit('goBackNotification');
    },
    initEditMode() {
      this.$emit('initEditMode');
    },
    saveChanges() {
      this.$emit('saveChanges');
    },
    updateEveryDay(value) {
      this.$emit('updateEveryDay', value);
    },
    async handleEditCancelled() {
      const warning1 = this.$createElement('p', { domProps: { innerHTML: this.$t('warning.unsaved_change') } });
      const warning2 = this.$createElement('p', { domProps: { innerHTML: this.$t('warning.confirm_leaving') } });
      const isConfirmed = await this.$confirmAction([warning1, warning2]);
      if (isConfirmed) {
        this.updateViewMode(true);
        this.$emit('resetTable');
      }
    },
    updateAppDisabled(value) {
      this.notificationSettingModel.setAppDisabled(value);
    },
    updateCalendar(value) {
      this.notificationSettingModel.setCalendar(value);
    },
    updateEmailDisabled(value) {
      this.notificationSettingModel.setEmailDisabled(value);
    },
    updateGallery(value) {
      this.notificationSettingModel.setGallery(value);
    },
    updateInstant(value) {
      this.notificationSettingModel.setInstant(value);
    },
    updateMessagesFromChildren(value) {
      this.notificationSettingModel.setMessagesFromChildren(value);
    },
    updateMessagesFromEmployees(value) {
      this.notificationSettingModel.setMessagesFromEmployees(value);
    },
    updateMessagesFromGuardians(value) {
      this.notificationSettingModel.setMessagesFromGuardians(value);
    },
    updateNotifyAssignedAsSubstituteTeacher(value) {
      this.notificationSettingModel.setNotifyAssignedAsSubstituteTeacher(value);
    },
    updateNotifyLessonNoteChanged(value) {
      this.notificationSettingModel.setNotifyLessonNoteChanged(value);
    },
    updatePickUpActivity(value) {
      this.notificationSettingModel.setPickUpActivity(value);
    },
    updatePost(value) {
      this.notificationSettingModel.setPost(value);
    },
    updateWidget(widgetId, value) {
      this.notificationSettingModel.setWidgetSettingById(widgetId, value);
    },
    updateScheduledTime(value) {
      this.notificationSettingModel.setScheduledTime(value);
    },
    updateSelectedAreas(value) {
      this.notificationSettingModel.setSelectedAreas(value);
    },
    updateVacationRequest(value) {
      this.notificationSettingModel.setVacationRequest(value);
    },
    updateMonday(value) {
      this.notificationSettingModel.setMonday(value);
    },
    updateTuesday(value) {
      this.notificationSettingModel.setTuesday(value);
    },
    updateWednesday(value) {
      this.notificationSettingModel.setWednesday(value);
    },
    updateThursday(value) {
      this.notificationSettingModel.setThursday(value);
    },
    updateFriday(value) {
      this.notificationSettingModel.setFriday(value);
    },
    updateSaturday(value) {
      this.notificationSettingModel.setSaturday(value);
    },
    updateSunday(value) {
      this.notificationSettingModel.setSunday(value);
    },
  },
};
</script>

<style scoped lang="scss">
@use '../../assets/scss/core/variables' as *;
@use '../../assets/scss/core/breakpoints' as *;
@use '../../assets/scss/elements/notificationSetting' as *;

footer {
  @include breakpoint-lg-down() {
    position: fixed !important;
    bottom: 80px;
    top: unset;
  }
}

.settings-label {
  display: block;
  &.large {
    margin-bottom: 15px;
  }
}

.red-border {
  .notification-settings-body-mobile & {
    display: block;
  }
}
</style>
